'use strict';

function vskloCartUrl() {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return String(root).replace(/\/$/, '') + '/cart';
}

const vskloCartMobile =
  typeof window.VSKLOIsCartMobile === 'function'
    ? window.VSKLOIsCartMobile()
    : Boolean(
        (window.matchMedia && window.matchMedia('(max-width: 1024px)').matches) ||
        (window.navigator &&
          (/Android|iPhone|iPod|iPad|IEMobile|Opera Mini|Mobile/i.test(String(window.navigator.userAgent || '')) ||
            (window.navigator.platform === 'MacIntel' && Number(window.navigator.maxTouchPoints || 0) > 1)))
      );

if (!vskloCartMobile) {
  const desktopRuntimeSrc = window.VSKLOCartComponentsDesktopSrc || './cart-components-desktop.js';
  await import(desktopRuntimeSrc);
} else if (!customElements.get('cart-notification')) {
  class VskloMobileCartNotification extends HTMLElement {
    getSectionsToRender() {
      return [];
    }

    setActiveElement(element) {
      this.activeElement = element || null;
    }

    cartAction() {}
    close() {}
    updateQuantity() {}

    open() {
      window.location.href = vskloCartUrl();
    }
  }

  customElements.define('cart-notification', VskloMobileCartNotification);
}
